<template>
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
  >
    <path
      d="M5.11111 8V5.00302C5.11014 4.01131 5.46755 3.0546 6.11396 2.31863C6.76036 1.58266 7.64965 1.11992 8.60917 1.02026C9.56869 0.920589 10.53 1.1911 11.3065 1.77928C12.083 2.36746 12.6192 3.23134 12.8111 4.20322M3.55556 8H14.4444C15.3036 8 16 8.71616 16 9.5996V15.4004C16 16.2838 15.3036 17 14.4444 17H3.55556C2.69645 17 2 16.2838 2 15.4004V9.5996C2 8.71616 2.69645 8 3.55556 8Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'UnlockIcon',
  };
</script>

